module.exports = __webpack_public_path__ + "img/9.7cb5bca4.png";